import { useEffect, useState } from 'react';
import { Common } from '@thecvlb/design-system/lib/src';

import { useLazyGetInsuranceProvidersQuery } from 'services/insurance/insurance';
import { useGetStatesQuery } from 'services/lookup/lookup';

import { selectOrchestrate, selectStates } from 'store';

import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';
import { setPartnerData } from 'containers/SignUp/signup.settings';

import { useAppSelector } from 'hooks';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';
import { FlowTypes } from 'utils/enums';

const State: React.FC<BasicSignupStepProps> = ({ moveToStep, selectedFlow }) => {
  const states = useAppSelector(selectStates);
  const { user } = useAppSelector(selectOrchestrate);
  const { send, isLoading } = useSubmitOrchestrateForm();
  const [getInsuranceProvider, { isLoading: isGettingInsuranceProviderInfo }] =
    useLazyGetInsuranceProvidersQuery();
  const { isFetching } = useGetStatesQuery();

  const [state, setState] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const longName = states.find((el) => el.value === state)?.label;
    e.preventDefault();
    if (!longName) {
      return window.location.reload();
    }
    if (
      [
        FlowTypes.WeightManagementFlowInsurance,
        FlowTypes.WeightManagementFlowInsuranceAlt
      ].includes(selectedFlow)
    ) {
      getInsuranceProvider({ state: longName })
        .unwrap()
        .then((res) => {
          sessionStorage.setItem(
            'isInsuranceAvailableInUsersState',
            res.length > 0 ? 'true' : 'false'
          );
          send(
            'user',
            { flowUrl: window.location.href, state: longName, ...setPartnerData(selectedFlow) },
            () => {
              moveToStep('next');
            }
          );
        });
    } else {
      send(
        'user',
        { flowUrl: window.location.href, state: longName, ...setPartnerData(selectedFlow) },
        () => {
          moveToStep('next');
        }
      );
    }
  };

  useEffect(() => {
    const preselectedState = user.state;
    if (preselectedState) {
      const shortName = states.find((el) => el.label === preselectedState)?.value;
      if (shortName) {
        setState(shortName);
      }
    }
  }, []);

  return (
    <form className="flex h-full flex-col items-center gap-6" onSubmit={handleSubmit}>
      <div className="flex place-content-center rounded-full bg-secondary-100 p-5">
        <Common.Icon className="size-12 flex-none text-secondary-600" name="map-point" />
      </div>
      <div className="flex flex-col gap-2 text-center text-primary-700">
        <h3 className="wm-signup-title">State of residence</h3>
        <span>
          To ensure we provide the best care and meet state requirements, please tell us which state
          you live in.
        </span>
      </div>
      <div className="w-full" data-testid="state_dropdown">
        <Common.SelectAlt
          loading={isFetching}
          options={states}
          placeholder="Select..."
          value={state}
          hideSuccessState
          onChange={setState}
        />
      </div>
      <Common.Button
        className="max-md:mt-auto"
        color="blue"
        disabled={!state}
        isLoading={isLoading || isGettingInsuranceProviderInfo}
        fullWidthOnMobile
      >
        Continue
      </Common.Button>
    </form>
  );
};

export default State;
